// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".xmlWrapper--1XB2j6Tv {\n  display: flex;\n}\n.text--EIPZEfID {\n  overflow: hidden;\n  width: 100%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xmlWrapper": "xmlWrapper--1XB2j6Tv",
	"text": "text--EIPZEfID"
};
export default ___CSS_LOADER_EXPORT___;
